// extracted by mini-css-extract-plugin
module.exports = {"controls":"styles_controls__13vSz","dialog_reject_draft":"styles_dialog_reject_draft__3KMMU"};